"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardMenuOverlay = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var faEllipsisV_1 = require("@fortawesome/pro-regular-svg-icons/faEllipsisV");
var classnames_1 = __importDefault(require("classnames"));
var CardMenuOverlay = function (props) {
    var _a = props.icon, icon = _a === void 0 ? faEllipsisV_1.faEllipsisV : _a;
    return (react_1.default.createElement(MenuOverlay, { className: (0, classnames_1.default)('card-menu-overlay', props.className), onClick: props.onClick },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon })));
};
exports.CardMenuOverlay = CardMenuOverlay;
var MenuOverlay = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 2rem;\n  text-align: right;\n  filter: drop-shadow(0px 0px 5px #000);\n  color: #000;\n  padding: 5px 10px;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 2rem;\n  text-align: right;\n  filter: drop-shadow(0px 0px 5px #000);\n  color: #000;\n  padding: 5px 10px;\n  cursor: pointer;\n"])));
exports.default = exports.CardMenuOverlay;
var templateObject_1;
